/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Row, Col, Card, CardBody, Table } from 'reactstrap';

import { StatusVenda } from '~/components/Status';
import { Cartoes } from '~/components/Cartoes';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';

import { TrStyled } from '../styles';

export function RecebimentosSimples({ user, recebimentos, projetos }) {
	function retornaModalidade(cell, row) {
		if (row.parcelas > 1) {
			return `Parcelado em ${row.parcelas}x`;
		}
		if (row.qtd_parcelas > 1) {
			return `Parcelado em ${row.qtd_parcelas}x`;
		}
		if (cell === 'crédito à vista') {
			return `Crédito à vista`;
		}
		if (cell === 'débito') {
			return `Débito`;
		}
		return cell;
	}

	function retornaTipoCupom(tipo) {
		if (tipo === null) {
			return `-`;
		}
		if (tipo === 0) {
			return `QD`;
		}
		if (tipo === 1) {
			return `Loja`;
		}
		return tipo;
	}

	return (
		<Table id="test-table-xls-button" responsive>
			<thead>
				<TrStyled>
					<th>Dt Recebimento</th>
					<th>Dt Venda</th>
					<th>Bandeira</th>
					<th>Modalidade</th>
					<th>Val Bruto</th>
					<th>Descontos</th>
					<th>Val Líquido</th>
					{projetos.includes(user.dados.tipo_projeto) && <th>Destino Cred.</th>}
					<th>Status</th>
				</TrStyled>
			</thead>
			<tbody>
				{recebimentos.lista.map((item, index) => {
					return (
						<tr key={`${item.autorizacao}-${index}`}>
							<td>
								{item.data_pagamento !== null
									? item.data_pagamento
									: item.data_agendado}
							</td>
							<td>
								{item.data_transacao}
							</td>
							<td>
								{item.bandeira &&
									<Cartoes cartao={item.bandeira} />
								}
							</td>
							<td>{retornaModalidade(item.modalidade, item)}</td>
							<td>
								{symbolPriceFormatter(item.valor_transacao)}
							</td>
							<td>{symbolPriceFormatter(item.valor_desconto)}</td>
							<td>{symbolPriceFormatter(item.valor_liquido)}</td>
							{projetos.includes(user.dados.tipo_projeto) &&
								<td>
									{retornaTipoCupom(item.tipo_cupom)}
								</td>
							}
							<td>
								<StatusVenda status={item.status} />
							</td>
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
}

export function CardSimples({ loadingRecebimentos, recebimentos }) {
	const cardSimples = [
		{
			nome: 'Saldo Bruto',
			nome_index: 'total_bruto',
			color: 'white',
			bg_color: color.softBlack,
		},
		{
			nome: 'Débito',
			nome_index: 'total_debito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Crédito à vista',
			nome_index: 'total_credito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Crédito Parcelado',
			nome_index: 'total_parcelado',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Desconto',
			nome_index: 'total_desconto',
			color: 'red',
			bg_color: color.white,
		},
		{
			nome: 'Saldo Líquido',
			nome_index: 'total_liquido',
			color: 'white',
			bg_color: color.softBlack,
		},
	];

	return (
		<Row className="mt-5">
			{cardSimples.map((item) => (
				<Col lg="2" md="4" key={item.id}>
					<Text>{item.nome}</Text>
					<Card
						style={{
							backgroundColor: item.bg_color,
							borderRadius: '0 10px 10px 10px',
						}}>
						<CardBody className="py-4 px-2">
							{loadingRecebimentos ? (
								<div className="d-flex justify-content-center">
									<LoaderMini />
								</div>
							) : item.nome_index === 'total_desconto' ? (
								<Text color={item.color} size="big" center>
									{`- ${symbolPriceFormatter(
										recebimentos.dados[item.nome_index]
									)}`}
								</Text>
							) : (
								<Text color={item.color} size="big" center>
									{symbolPriceFormatter(
										recebimentos.dados[item.nome_index]
									)}
								</Text>
							)}
						</CardBody>
					</Card>
				</Col>
			))}
		</Row>
	);
}
